import type { TFunction } from 'i18next';

import { pickRowId } from './tableExcelExport';

export const DELETED_COLUMN_HEADER = 'To Be Deleted';

export const DELETED_COLUMN_HEADERS = [
  DELETED_COLUMN_HEADER,
  'deleted',
  'Deleted',
  'DELETED',
] as const;

const DELETE_YES_VALUES = new Set(['yes', 'y', 'true', '1', 'sim', 'sí', 'si']);

export function parseDeletedFlag(value: unknown): boolean | null {
  if (value == null || String(value).trim() === '') {
    return null;
  }
  const normalized = String(value).trim().toLowerCase();
  if (DELETE_YES_VALUES.has(normalized)) {
    return true;
  }
  if (normalized === 'no' || normalized === 'n' || normalized === 'false' || normalized === '0') {
    return false;
  }
  return null;
}

export function isRowMarkedForDelete(row: Record<string, unknown>): boolean {
  for (const header of DELETED_COLUMN_HEADERS) {
    const flag = parseDeletedFlag(row[header]);
    if (flag === true) {
      return true;
    }
  }
  return false;
}

export function formatDeletedExportValue(isDeleted: boolean | undefined | null): string {
  if (isDeleted) {
    return 'yes';
  }
  return '';
}

export function readDeletedCell(row: Record<string, unknown>): unknown {
  for (const header of DELETED_COLUMN_HEADERS) {
    if (header in row) {
      return row[header];
    }
  }
  return undefined;
}

export function isDeletedColumnKey(key: string): boolean {
  return DELETED_COLUMN_HEADERS.includes(key as (typeof DELETED_COLUMN_HEADERS)[number]);
}

export type ImportRowClassification = {
  rowsForUpsert: Record<string, unknown>[];
  deleteIds: string[];
  errors: string[];
};

export function classifyImportRows(
  rows: Record<string, unknown>[],
  existingIds: Set<string>,
  t: TFunction,
): ImportRowClassification {
  const rowsForUpsert: Record<string, unknown>[] = [];
  const deleteIds: string[] = [];
  const errors: string[] = [];

  rows.forEach((row, index) => {
    const line = index + 2;
    if (!isRowMarkedForDelete(row)) {
      rowsForUpsert.push(row);
      return;
    }

    const id = pickRowId(row);
    if (!id) {
      errors.push(t('common.import.deleteRequiresId', { line }));
      return;
    }
    if (!existingIds.has(id)) {
      errors.push(t('common.import.idNotFound', { line, id }));
      return;
    }
    deleteIds.push(id);
  });

  return { rowsForUpsert, deleteIds, errors };
}
